import { useQuery } from '@tanstack/react-query';
import { getCurrentCheckoutSession } from '../services/subscriptions.api';

export function useCheckoutSession(checkoutSession: string | undefined) {
  return useQuery({
    queryKey: ['checkout-session', checkoutSession],
    queryFn: () => getCurrentCheckoutSession(checkoutSession!),
    enabled: !!checkoutSession,
    retry: false,
  });
}
